<template>
  <div :class="['apInputTel', {'apInputTel--error': hasErrorText}]">
    <div class="apInputTel__inner">
      <label
        v-if="label" 
        class="apInputTel__label"
      >
        {{ label }}
      </label>
      <div class="apInputTel__field">
        <span class="apInputTel__code">+7</span>
        <input
          v-mask="'### ### ## ##'"
          class="apInputTel__input"
          type="tel"
          :value="modelValue"
          :disabled="disabled"
          @input="input"
        >
        <span class="apInputTel__icon">
          <operator-icon
            v-show="iconName"
            :name="iconName"
          />
        </span>
      </div>
      <transition
        name="fade" 
        mode="out-in"
      >
        <div
          v-if="hintOrError"
          class="apInputTel__hint"
        >
          {{ hintOrError }}
        </div>
      </transition>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { mask } from 'vue-the-mask';

import operatorIcon from '../icons/operatorIcon.vue';


export default defineComponent({
  name: 'ApInputTel',

  directives: { mask },

  components: {
    operatorIcon
  },
  
  props: {
    type: {
      type: String,
      default: 'default',
    },
    modelValue: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },

  setup(props, { emit }) {
    const store = useStore();
    
    const hasErrorText = computed(() => props.errorText.length > 0);
    
    const hintOrError = computed(() => {
      if (hasErrorText.value){
        return props.errorText;
      }
      return props.hint;
    });

    const input = (e: Event): void => {
      const element = e.target as HTMLInputElement;
      emit('update:modelValue', element.value.replace(/\s/g, ''));
    };

    onBeforeUnmount(() => {
      store.commit('setOperator', {});
    });

    return {
      hasErrorText,
      hintOrError,
      input,
    };
  },
});
</script>

<style lang="scss" scoped>
.apInputTel{
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  &__input{
    font-size: 16px;
    line-height: 22px;
    width: 100%;
    border: none;
    &:focus{
      outline: none;
    }
    &::placeholder{
      padding-left: 2px;
      color: $primary-gray;
    }
    &:disabled{
      background-color: #ffffff;
    }
  }
  &__code{
    margin-right: 3px;
    line-height: 22px;
  }
  &__hint {
      margin-top: 6px;
      font-size: 12px;
      color: rgba(0,0,0, .6);
  }
  &__field{
    display: flex;
    overflow: hidden;
    padding: 10px;
    align-items: center;
    width: 100%;
    position: relative;
  }
  &__label{
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: $secondary-black;
    margin-bottom: 6px;
    display: block;
  }
  &__icon{
    display: block;
    height: 24px;
    width: 24px;
  }
}

.default{
  .apInputTel{
    &__field{
      border: 1px solid $secondary-gray;
      border-radius: 6px;
      line-height: 22px;
    }
  }
  .apInputTel--error{
  .apInputTel{
    &__field{
      border: 1px solid red;
    }
    &__label{
      color: red;
    }
    &__hint{
      color: red;
    }
    &__code{
      color: red;
    }
    &__input{
      color: red;
    }
  }
}
}
.tele2{
  .apInputTel{
    font-family: 'Open Sans';
    &__field{
      border-bottom: 1px solid $tele2-primary-gray;
      line-height: 24px;
      padding: 8px 0;
    }
    &__label{
      font-weight: 600;
      color: $tele2-primary-gray;
      font-size: 13px;
      line-height: 16px;
      margin-bottom: 7px;
      
    }
  }
  .apInputTel--error{
  .apInputTel{
    &__field{
      border-bottom-color: red;
    }
    &__label{
      color: red;
    }
    &__hint{
      color: red;
    }
    &__code{
      color: red;
    }
    &__input{
      color: red;
    }
  }
}
}
.altel{
  .apInputTel{
    &__field{
      border: 1px solid $secondary-gray;
      background: #F8F8F8;
      line-height: 24px;
      border-radius: 4px;

    }
    &__input{
      background: #F8F8F8;
    }
    &__label{
      font-weight: 500;
      color: $primary-gray;
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 8px;
    }
  }
  .apInputTel--error{
  .apInputTel{
    &__field{
      border-color: red;
    }
    &__label{
      color: red;
    }
    &__hint{
      color: red;
    }
    &__code{
      color: red;
    }
    &__input{
      color: red;
    }
  }
}
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
